<script setup lang="ts">
import { PURCHASE_LINKS } from "~/lib/book-purchase";

const livrariasUrl = PURCHASE_LINKS.livrariasCuritiba;
</script>

<template>
  <section class="relative py-16 md:py-20 overflow-hidden">
    <div class="absolute inset-0 bg-[#003B71]" />
    <div
      class="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_30%_50%,#E31E24_0%,transparent_50%)]"
    />

    <div
      class="relative container max-w-screen-xl mx-auto px-4"
      data-aos="fade-up"
    >
      <div
        class="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 rounded-3xl border border-white/10 bg-white/5 backdrop-blur-sm p-8 md:p-12"
      >
        <div class="flex-shrink-0">
          <img
            src="/images/partners/livrarias-curitiba.png"
            alt="Livrarias Curitiba"
            class="h-16 md:h-20 w-auto object-contain bg-white rounded-xl p-3 md:p-4"
          />
        </div>

        <div class="flex-1 text-center lg:text-left text-white">
          <span
            class="inline-block text-[#E31E24] text-xs uppercase tracking-widest font-semibold mb-3"
          >
            {{ $t("store.badge") }}
          </span>
          <h2 class="font-neutron italic text-3xl md:text-4xl mb-3">
            {{ $t("store.title") }}
          </h2>
          <p class="text-white/75 text-base md:text-lg max-w-2xl leading-relaxed">
            {{ $t("store.description") }}
          </p>
          <div class="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
            <div class="text-white">
              <span class="text-sm text-white/60">{{ $t("buy.for-only") }}</span>
              <div class="text-4xl font-semibold">
                R$ <span class="text-5xl font-neutron italic">99</span>,90
              </div>
            </div>
            <span class="hidden sm:block w-px h-12 bg-white/20" />
            <span class="text-sm text-white/60">
              {{ $t("store.edition") }}
            </span>
          </div>
        </div>

        <div class="flex-shrink-0 w-full sm:w-auto">
          <a
            :href="livrariasUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center justify-center gap-2 w-full sm:w-auto rounded-xl bg-[#E31E24] hover:bg-[#c91920] text-white font-semibold text-lg px-10 py-4 transition-all hover:scale-105 shadow-lg shadow-[#E31E24]/30"
          >
            {{ $t("store.button") }}
            <Icon name="ic:round-open-in-new" class="text-xl" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
